import type { UploadLayout } from '@erp/rpc';

/** Built-in layouts were never saved; they carry a fixed, obviously-synthetic time. */
export const BUILT_IN_LAYOUT_EPOCH = new Date(0);

function supplierKey(layout: UploadLayout): string {
  return layout.name.trim().toLowerCase();
}

/**
 * The suppliers a file can be converted for: every saved layout, plus each
 * built-in one the org has not saved its own layout for. Once a layout with the
 * same supplier name is saved it replaces the built-in, so the saved layout —
 * and the rules scoped to it — is the only way to convert that supplier.
 */
export function availableSupplierLayouts(
  saved: UploadLayout[],
  builtIns: UploadLayout[],
): UploadLayout[] {
  const savedSuppliers = new Set(saved.map(supplierKey));
  return [
    ...saved,
    ...builtIns.filter((layout) => !savedSuppliers.has(supplierKey(layout))),
  ];
}
